import { isNil } from 'lodash';
import React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import {
  SpaceProps,
  alignSelf,
  color,
  fontFamily,
  fontSize,
  fontWeight,
  height,
  justifySelf,
  space,
  textAlign,
  width,
} from 'styled-system';
import {
  ColoringProps,
  SelfPositioningProps,
  SizingProps,
  TypographyProps,
} from '~frontend-common/lib/styled-components';
import { styled } from '~ui-kit/styled-components';

export interface InternalLinkProps
  extends RouterLinkProps,
    SpaceProps,
    ColoringProps,
    TypographyProps,
    SelfPositioningProps,
    SizingProps {
  color?: string;
}

export function InternalLink({ to, children, ...rest }: InternalLinkProps) {
  return isNil(to) ? (
    <span>{children}</span>
  ) : (
    <StyledLink to={to} {...rest}>
      {children}
    </StyledLink>
  );
}

const StyledLink = styled(RouterLink)`
  ${fontSize};
  ${space};
  ${color};
  ${fontWeight};
  ${textAlign};
  ${fontFamily};
  ${alignSelf};
  ${justifySelf};
  ${height};
  ${width};

  display: inline;
  &:hover {
    color: ${(props) => props.theme.colors.linkHover};
  }
`;
